<tt-page *ngIf="!!setting">
    <tt-page-heading [ttModel]="'p2_m_vatreports'" ttTranslate></tt-page-heading>

    <div class="tt-vatreports__header">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-select
                ttRememberId="w_accountingprocessing.businessco_no"
                ttLabel="businessco"
                [(ttModel)]="setting.businessco_no"
                (ttModelChange)="onChanged($event, 'businessco_no')"
                [ttData]="selectListCompanies"
                ttDataId="businessco_no"
                ttDataName="company_name"
            ></tt-select>
            <tt-select
                ttRememberId="vatreports.accounting_year"
                ttLabel="accounting_year"
                [(ttModel)]="setting.accounting_year"
                (ttModelChange)="onChanged($event, 'accounting_year')"
                [ttData]="selectListAccountingYears"
                ttDataId="transyear"
                ttDataName="transyear_name"
            ></tt-select>
        </tt-card>
        <tt-toast *ngIf="!!setting.message" [ttType]="setting.type">
            <span title style="white-space: pre-wrap">{{ setting.message }}</span>
        </tt-toast>
    </div>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
